import oldMapImage from "../assets/images/map_old.png";
import newMapImage from "../assets/images/map.png";

// Umzug: bis einschließlich 11.10.2026 alter Standort, ab 12.10.2026 der neue.
const MOVE_DATE = "2026-10-12";

const OLD_LOCATION = {
    venue: null,
    street: "Kanalstraße 72",
    city: "76356 Weingarten",
    center: [49.0461263, 8.5118614],
    mapImage: oldMapImage,
};

const NEW_LOCATION = {
    venue: "Mineralix-Arena",
    street: "Ringstraße 67",
    city: "76356 Weingarten (Baden)",
    center: [49.0500615, 8.519812],
    mapImage: newMapImage,
};

// Heutiges Datum als "YYYY-MM-DD" in deutscher Zeit.
const berlinToday = () =>
    new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Berlin" }).format(
        new Date(),
    );

export const isNewLocation = () => berlinToday() >= MOVE_DATE;

export const getLocation = () =>
    isNewLocation() ? NEW_LOCATION : OLD_LOCATION;

export { NEW_LOCATION };
